import {
  ITask,
  PagedRequest,
  PagedResponse,
  TaskStatus,
} from '@topshots/core-models';
import { topshotsAPI } from '../../app/api';
// import { Task, TaskStatus } from './tasks.types';

const tasksApi = topshotsAPI.injectEndpoints({
  endpoints: (build) => ({
    getTasks: build.query<
      PagedResponse<ITask[]>,
      PagedRequest & { status?: TaskStatus }
    >({
      query: (request) => ({
        url: 'tasks',
        method: 'GET',
        params: request,
      }),
      providesTags: (result, error, page) =>
        result
          ? [
              // Provides a tag for each enquiry in the current page,
              // as well as the 'PARTIAL-LIST' tag.
              ...result.data.map(({ _id }) => ({
                type: 'Tasks' as const,
                id: _id.toString(),
              })),
              { type: 'Tasks', id: 'PARTIAL-LIST' },
            ]
          : [{ type: 'Tasks', id: 'PARTIAL-LIST' }],
    }),
    getTask: build.query<ITask, string>({
      query: (id) => ({
        url: `tasks/${id}`,
        method: 'GET',
      }),
      providesTags: (result, error, page) => [
        { type: 'Tasks' as const, id: result?._id.toString() },
      ],
    }),
    deleteTask: build.mutation<void, string>({
      query: (id) => ({
        url: `tasks/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, product) => [{ type: 'Tasks' }],
    }),
  }),
});

export const { useGetTaskQuery, useGetTasksQuery, useDeleteTaskMutation } =
  tasksApi;
